@if (showLoader) {
  <div class="loader" style="position: fixed;">
    <div class="spinner"></div>
  </div>
}

<app-modal></app-modal>

<router-outlet></router-outlet>